import API from '../dataApi';

// -- Auth ----------------------------------------------------------------------
export const registerMember = (data) => API.post('/auth/member/register', data);
export const loginMember = (data) => API.post('/auth/member/login', data);
export const checkAdminAvailability = (data) => API.post('/auth/admin/check-availability', data);
export const loginAdmin = (data) => API.post('/auth/admin/login', data);
export const loginSuperAdmin = (data) => API.post('/auth/super-admin/login', data);
export const getMe = () => API.get('/auth/me');

// Email verification
// GET only checks token validity (no side effects) -- email clients/security
// scanners auto-prefetch links, so the actual verification must happen on an
// explicit user action via POST, not on page load.
export const checkVerificationToken = (token) => API.get(`/auth/verify-email/${token}`);
export const verifyEmail = (token) => API.post('/auth/verify-email', { token });
export const resendVerification = () => API.post('/auth/resend-verification');

// Forgot / reset password (no auth required)
export const forgotPassword = (email) => API.post('/auth/forgot-password', { email });
export const resetPassword = (token, password) => API.post(`/auth/reset-password/${token}`, { password });
export const changePassword = (data) => API.put('/auth/change-password', data);

// Mobile verification
export const requestMobileVerification = (phone) => API.post('/auth/mobile/request-verification', { phone });
export const verifyMobileCode = (code) => API.post('/auth/mobile/verify', { code });

// Co-admin invite flow
export const getInvitePreview = (token) => API.get(`/auth/invite/${token}`);
export const acceptInvite = (data) => API.post('/auth/accept-invite', data);

// Legacy aliases used by PaymentPage
export const register = registerMember;
export const login = loginMember;
